import moment from 'js-utils/moment';
import gettext from 'js-utils/gettext';
import ngettext from 'js-utils/ngettext';
import { formatMajorMoney } from 'js-utils/intl';
import { FREE_FLAG_TEXT, MOMENT_DATE_AND_TIME_FORMAT_STRING, MOMENT_DATE_FORMAT_STRING } from './constants';
/*
@param {string} startDate - YYYY-MM-DD formatted date string
@param {string} startTime - HH:MM:SS formatted time string
@param {number} instanceCount - Number of upcoming repeating event instances
*/

export var getEventTimeString = function getEventTimeString(startDate, startTime, instanceCount) {
  var dateString = moment(startDate).format(MOMENT_DATE_FORMAT_STRING);

  if (startTime) {
    dateString = moment("".concat(startDate, " ").concat(startTime)).format(MOMENT_DATE_AND_TIME_FORMAT_STRING);
  }

  if (instanceCount) {
    //Translators: Sun, Dec 12th + more events
    //Translators: Sun, Dec 12th, 7:00pm + 10 more events
    //Translators: Sun, Dec 12th, 4:00 + 4 more events
    dateString = ngettext('%(dateString)s + %(instanceCount)s more event', '%(dateString)s + %(instanceCount)s more events', instanceCount === 1, {
      dateString: dateString,
      instanceCount: instanceCount
    });
  }

  return dateString;
};
/*
@param {object} minPrice - Object containing the data for properly formatting price string
@param {bool} isFree - Flag which sets if the event is a free event or not
*/

export var getPriceInfo = function getPriceInfo() {
  var minPrice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isFree = arguments.length > 1 ? arguments[1] : undefined;
  var minPriceValue = minPrice.minPriceValue,
      currency = minPrice.currency,
      currencyFormat = minPrice.currencyFormat;
  var priceString;

  if (minPriceValue <= 0 && !isFree) {
    return priceString;
  }

  if (minPriceValue && currency) {
    var formattedMoney = formatMajorMoney(minPriceValue, currency, currencyFormat);
    priceString = gettext('Starts at %(valueString)s', {
      valueString: formattedMoney
    });
  }

  if (isFree) {
    priceString = FREE_FLAG_TEXT;
  }

  return priceString;
};
/*
@param {string} minPrice - Object containing the data for properly formatting price string
@param {bool} isFree - Flag which sets if the event is a free event or not
@param {string} ticketsBy - The source of the ticket
*/

export var getFormattedPriceString = function getFormattedPriceString(minPrice, isFree, ticketsBy) {
  var priceString = getPriceInfo(minPrice, isFree);
  var formattedPriceString;
  var formattedTicketsByString;

  if (priceString) {
    formattedPriceString = priceString;

    if (ticketsBy && ticketsBy !== 'Eventbrite') {
      formattedTicketsByString = gettext('on %(ticketsBy)s', {
        ticketsBy: ticketsBy
      });
    }
  } else if (ticketsBy && ticketsBy !== 'Eventbrite') {
    formattedTicketsByString = gettext('On %(ticketsBy)s', {
      ticketsBy: ticketsBy
    });
  }

  if (priceString && formattedTicketsByString) {
    formattedPriceString = gettext('%(priceString)s • %(formattedTicketsByString)s', {
      priceString: priceString,
      formattedTicketsByString: formattedTicketsByString
    });
  }

  if (!priceString && formattedTicketsByString) {
    formattedPriceString = formattedTicketsByString;
  }

  return formattedPriceString;
};